import {
  Grid,
  Card,
  CardMedia,
  Typography,
  IconButton,
} from "@material-ui/core";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import LogoutIcon from "@material-ui/icons/ExitToApp";
import { useAuth } from "../../contexts/AuthContext";
import imgUrl from "../../components/assets/images/Sparrow.svg";
import { useHistory } from "react-router-dom";

import React, {useEffect} from "react";

import { theme1 } from "../Header/header.css";

/* Header component  */
const Header = () => {
  const fontSize = "large";
  const history = useHistory();
  const { currentUser, logout } = useAuth();

  //handle sign out
  const handleClickSignOut = async () => {
    try {
      await logout();
      history.push("/login");
    } catch {
      console.log("Failed to log out");
    }
  };

  return (
    <Card
      style={{
        height: "4.5vw",
        boxShadow: "0px 2px 4px #15223229",
        marginBottom: "5%",
        backgroundColor: "white",
        width: "100%",
      }}
    >
      <Grid container>
        <Grid item xs={6}>
          <CardMedia
            component="img"
            image={imgUrl}
            alt={"img"}
            style={{
              top: "-1.5rem",
              width: "15%",
              position: "relative",
            }}
          />
        </Grid>

        <Grid
          item
          xs={3}
          style={{
            textAlign: "left",
            margin: "2rem 0rem 1rem 0rem",
            position: "fixed",
            right: "250px",
            top: "-1rem",
          }}
        >
          <IconButton
            /*  aria-label="John Snow" */
            style={{
              "&:hover": { color: "red" },
              paddingLeft: 0,
              color: "#000000",
              [theme1.breakpoints.up("xl")]: {
                position: "relative",
                top: "-0.125rem",
              },
              [theme1.breakpoints.up("lg")]: {
                position: "relative",
                top: "-0.75rem",
              },
              [theme1.breakpoints.up("sm")]: {
                position: "relative",
                top: "-0.9375rem",
              },
            }}
            color="primary"
            onClick={handleClickSignOut}
          >
            <LogoutIcon fontSize={fontSize} />
          </IconButton>
          <Typography
            component="span"
            color="primary"
            textAlign="left"
            style={{
              paddingLeft: 0,
              pointerEvents: "none",
              color: "#000000",
              [theme1.breakpoints.up("xl")]: {
                position: "relative",
                top: "-0.125rem",
              },
              [theme1.breakpoints.up("lg")]: {
                position: "relative",
                top: "-0.75rem",
              },
              [theme1.breakpoints.up("sm")]: {
                position: "relative",
                top: "-0.9375rem",
              },
            }}
          >
            Sign Out
          </Typography>
        </Grid>

        <Grid
          item
          xs={3}
          style={{
            textAlign: "left",
            margin: "2rem 0rem 1rem 0rem",
            position: "fixed",
            right: "60px",
            top: "-1rem",
          }}
        >
          <IconButton
            /*  aria-label="John Snow" */
            style={{
              "&:hover": { color: "red" },
              paddingLeft: 0,
              color: "#000000",
              pointerEvents: "none",
              [theme1.breakpoints.up("xl")]: {
                position: "relative",
                top: "-0.125rem",
              },
              [theme1.breakpoints.up("lg")]: {
                position: "relative",
                top: "-0.75rem",
              },
              [theme1.breakpoints.up("sm")]: {
                position: "relative",
                top: "-0.9375rem",
              },
            }}
            color="primary"
          >
            <AccountCircleIcon fontSize={fontSize} />
          </IconButton>
          <Typography
            component="span"
            color="primary"
            textAlign="left"
            style={{
              paddingLeft: 0,
              pointerEvents: "none",
              color: "#000000",
              [theme1.breakpoints.up("xl")]: {
                position: "relative",
                top: "-0.125rem",
              },
              [theme1.breakpoints.up("lg")]: {
                position: "relative",
                top: "-0.75rem",
              },
              [theme1.breakpoints.up("sm")]: {
                position: "relative",
                top: "-0.9375rem",
              },
            }}
          >
            User
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
};
export default Header;
